import * as React from "react"

const SvgComponent = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40}
        id={"circle-target"}
         viewBox={`0 0 40 40`}
         {...props}>


        <circle
        id={"services-target"}
            cx={20}
            cy={20}
            r={20}
            // transform="translate(15 0)"

            fill="#fff"
        />

    </svg>
)
export default SvgComponent
